/**
 * Errors Show Subcommand
 */
import { Command } from 'commander';
import { ErrorLogService } from '../../services/error-log.service.js';

export function createErrorsShowSubcommand(): Command {
  return new Command('show')
    .description('Xem chi tiết error log')
    .argument('[id]', 'Error log id (default: latest)')
    .option('--json', 'Output JSON format')
    .action(async (id: string | undefined, options: { json?: boolean }) => {
      const service = new ErrorLogService();
      const paths = await service.list();

      if (paths.length === 0) {
        console.log('✨ Không có error logs nào.');
        return;
      }

      let targetPath: string | undefined;
      if (!id) {
        targetPath = paths[0];
      } else {
        targetPath = paths.find((p) => p.endsWith(`${id}.json`));
      }

      if (!targetPath) {
        console.error(`❌ Không tìm thấy log: ${id}`);
        process.exit(1);
      }

      const read = await service.readLog(targetPath);
      if (!read) {
        console.error('❌ Không thể đọc log file.');
        process.exit(1);
      }

      console.log(JSON.stringify(read.entry, null, 2));
    });
}
